import { env } from '@/env';

export function GoogleAnalytics() {
  if (!env.VITE_GOOGLE_ANALYTICS_ID) return null;

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${env.VITE_GOOGLE_ANALYTICS_ID}`}
      />
      <script
        // biome-ignore lint/security/noDangerouslySetInnerHtml: grant for Google Analytics
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', '${env.VITE_GOOGLE_ANALYTICS_ID}');
        `,
        }}
      />
    </>
  );
}
